<template>
  <div class="container">
    <div class="filter-container">
      <el-button
          class="filter-item"
          size="mini"
          type="primary"
          style="margin-bottom:10px"
          icon="el-icon-plus"
          @click="handleCreate"
      >添加数据库</el-button>
    </div>
    <el-table
        v-loading="listLoading"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%;"
    >
      <el-table-column label="名称" align="center">
        <template v-slot="{row}">
          <span>{{ row.Name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="IP地址" align="center">
        <template v-slot="{row}">
          <span>{{ row.ServerAdd }}</span>
        </template>
      </el-table-column>
      <el-table-column label="端口号" align="center">
        <template v-slot="{row}">
          <span>{{ row.Port }}</span>
        </template>
      </el-table-column>
      <el-table-column label="账号" align="center">
        <template v-slot="{row}">
          <span>{{ row.UserName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="数据库" align="center">
        <template v-slot="{row}">
          <span>{{ row.DBName }}</span>
        </template>
      </el-table-column>
       <el-table-column label="字符编码" align="center">
        <template v-slot="{row}">
          <span>{{ row.Charset }}</span>
        </template>
      </el-table-column>
      <!-- 新增状态开关列 -->
      <el-table-column label="状态" align="center">
        <template v-slot="{row}">
          <el-switch
            v-model="row.UseZ3950"
            active-text="启用"
            inactive-text="禁用"
            @change="handleStatusChange(row)"
            :active-value="true"
            :inactive-value="false"
            :disabled="isSwitchDisabled(row)"
          />
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          class-name="small-padding fixed-width"
          fixed="right"
      >
        <template v-slot="{row}">
          <el-button type="primary" size="mini" @click="handleUpdate(row)">编辑</el-button>
          <el-button
              v-if="row.status!='deleted'"
              size="mini"
              type="danger"
              @click="handleDelete(row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top:50px;text-align:right;">
      <el-pagination
          background
          :total="total"
          :current-page="listQuery.Page"
          :page-size="listQuery.Perpage"
          :page-sizes="[5, 10, 20, 30, 40, 50, 100]"
          layout="prev,pager,next,jumper,sizes,total"
          @size-change="pageSizeChange"
          @current-change="currPageChange"
      />
    </div>
    <el-dialog width="30%" :title="textMap[dialogStatus]" v-model="dialogFormVisible" :close-on-click-modal="false">
      <el-form
          ref="dataForm"
          :rules="rules"
          :model="formModel"
          label-position="left"
          label-width="100px"
          style="margin-left:40px;"
          size="small"
      >
          <el-form-item label="名称" prop="Name">
          <el-input v-model="formModel.Name" placeholder="请输入名称" />
        </el-form-item>
        <el-form-item label="IP地址" prop="ServerAdd">
          <el-input v-model="formModel.ServerAdd" placeholder="请输入IP地址" />
        </el-form-item>
         <el-form-item label="端口号" prop="Port">
          <el-input v-model.number="formModel.Port" placeholder="请输入端口号" />
        </el-form-item>
        <el-form-item label="账号" prop="UserName">
          <el-input v-model="formModel.UserName" placeholder="请输入账号" />
        </el-form-item>
        <el-form-item label="密码" prop="Password">
          <el-input v-model="formModel.Password" placeholder="请输入密码" show-password />
        </el-form-item>
       <el-form-item label="数据库名称" prop="DBName">
          <el-input v-model="formModel.DBName" placeholder="请输入数据库名称"  />
        </el-form-item>
        <el-form-item label="字符编码" prop="Charset">
         <el-select v-model="formModel.Charset" placeholder="请选择字符编码" style="width:100%">
                <el-option label="UTF-8" value="UTF-8" />
  <el-option label="GBK" value="GBK" />
          </el-select>
        </el-form-item>
        
      </el-form>
      <div class="dialog-footer">
        <div style="float: right">
          <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" size="mini" @click="btnAddorMod">确定</el-button>
        </div>
        <p style="color: #ffffff">三阅</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import zhCn from 'element-plus/lib/locale/lang/zh-cn';
import {BASE_URL} from "@/utils/constants";
export default {
  name: 'Holiday',
  computed: {
    zhCn() {
      return zhCn;
    }
  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        Page: 1,
        Perpage: 10,
        OrderBy: { "DTCreatedDate": -1 },
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加'
      },
      rules: {
         Name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        ServerAdd: [
          { required: true, message: '请输入IP地址', trigger: 'blur' }
        ],
        Port: [
          { required: true, message: '请输入端口号', trigger: 'blur' }
        ],
        UserName: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        Password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        Database: [
          { required: true, message: '请选择数据库', trigger: 'change' }
        ],
        DBName:[
          { required: true, message: '请输入数据库名称', trigger: 'blur' }
        ],
        Charset: [
          { required: true, message: '请输入字符编码', trigger: 'blur' }
        ]
      },
      formModel: {}
    };
  },
  created() {
    this.getList();
  },
  methods: {
    choose() {
      if (!this.formModel.DTStartTime || !this.formModel.DTEndTime) return;
      const day1 = new Date(this.formModel.DTStartTime);
      const day2 = new Date(this.formModel.DTEndTime);
      if (day2.getTime() < day1.getTime()) {
        ElMessage.error('日期选择错误');
        this.formModel.DTEndTime = '';
      }
    },
    formatStartDate(dateStr) {
      const date = new Date(dateStr);
      //console.log('timezone', this.toLocalISO(date));
      return this.toLocalISO(date);
    },

    formatEndDate(dateStr) {
      const date = new Date(dateStr);
      return this.toLocalISO(date);
    },
    toLocalISO(date) {
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Asia/Shanghai',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        fractionalSecondDigits: 3,
        hour12: false
      });
      const parts = formatter.formatToParts(date);
      const partValues = {};
      parts.forEach(part => {
        partValues[part.type] = part.value;
      });
      const year = partValues.year;
      const month = partValues.month;
      const day = partValues.day;
      const hour = partValues.hour;
      const minute = partValues.minute;
      const second = partValues.second;
      let millisecond = partValues.fractionalSecond || '000';

      millisecond = millisecond.padEnd(3, '0');

      return `${year}-${month}-${day}`;
      // return `${year}-${month}-${day}T${hour}:${minute}:${second}.${millisecond}+08:00`;
    },
    getList() {
      this.$axios({
        url: BASE_URL + 'z3950/list',
        method: 'post',
        data: JSON.stringify(this.listQuery),
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.ok) {
          this.list = res.data.msg;
          this.total = res.data.total;
          this.listLoading = false;
        }
      });
    },
    handleCreate() {
      this.formModel = {};
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    toLocalISOString(date) {
      const pad = n => (n < 10 ? '0' + n : n);
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());
      const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

      // 获取当前时区与 UTC 的分钟差，注意这里要取负数才是正确的偏移
      const offset = -date.getTimezoneOffset();
      const sign = offset >= 0 ? '+' : '-';
      const offsetHours = pad(Math.floor(Math.abs(offset) / 60));
      const offsetMinutes = pad(Math.abs(offset) % 60);

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}${sign}${offsetHours}:${offsetMinutes}`;
    },

    btnAddorMod() {
      // 设置默认字符编码为 utf-8
      // if (!this.formModel.Charset) {
      //   this.formModel.Charset = 'utf-8';
      // }
    
      const parem = {
        Name: this.formModel.Name,
        ServerAdd: this.formModel.ServerAdd, // 修复：原来是 formModel.StrTitle
        Port: this.formModel.Port,
        UserName: this.formModel.UserName,
        Password: this.formModel.Password,
        DBName: this.formModel.DBName,
        Charset: this.formModel.Charset,
      };
      const pattern = /^\d{4}-\d{2}-\d{2}$/;

       console.log("当前值为"+ this.dialogStatus);

      if (this.dialogStatus === 'create') {
        this.$refs['dataForm'].validate(valid => {
          if (valid) {
            this.$axios({
              url: BASE_URL + 'z3950/create',
              method: 'post',
              data: JSON.stringify(parem),
              headers: {
                'Content-Type': 'application/json',
                'dataType': 'json',
                'Authorization': localStorage.getItem("token")
              }
            }).then((res) => {
              if (res.data.ok) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });
              }
              this.getList();
              this.dialogFormVisible = false;
            });
          }
        });
      } else {
        parem.StrID = this.formModel.StrID;
        console.log("当前值为"+ this.formModel.StrID);
        // 编辑操作同样适用
        this.$refs['dataForm'].validate(valid => {
          if (valid) {
            this.$axios({
              url: BASE_URL + 'z3950/update' ,
              method: 'post',
              data: JSON.stringify(parem),
              headers: {
                'Content-Type': 'application/json',
                'dataType': 'json',
                'Authorization': localStorage.getItem("token")
              }
            }).then((res) => {
              if (res.data.ok) {
                this.$message({
                  message: '编辑成功',
                  type: 'success'
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });
              }
              this.getList();
              this.dialogFormVisible = false;
            });
          }
        });
      }
    },

    convertToLocalDate(utcDateStr) {
      // 解析 UTC 时间，确保输入格式正确（例如 "2025-02-28T00:00:00Z"）
      const date = new Date(utcDateStr);
      if (isNaN(date.getTime())) {
        console.error("Invalid date string:", utcDateStr);
        return ""; // 如果解析失败，返回空字符串
      }
      // 转换为东八区时间，增加 8 小时（8 * 60 * 60 * 1000 毫秒）
      const localDate = new Date(date.getTime() + 8 * 60 * 60 * 1000);
      // 使用 UTC 方法提取东八区时间的年、月、日
      const year = localDate.getUTCFullYear();
      const month = String(localDate.getUTCMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需 +1
      const day = String(localDate.getUTCDate()).padStart(2, '0');
      return `${year}-${month}-${day}`; // 返回格式化的东八区日期
    },
    handleUpdate(row) {
      this.dialogStatus = 'update';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
     
       this.formModel = {
        ...row, // 保留其他字段
      };
      console.log(this.formModel);
      
    },
    handleDelete(row) {
      const parem = {
        StrID: row.StrID,
      };
      this.$confirm('确定要删除数据库吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.$axios({
          url: BASE_URL + 'z3950/del' ,
          method: 'post',
           data: JSON.stringify(parem),

          headers: {
            'Content-Type': 'application/json',
            'dataType': 'json',
            'Authorization': localStorage.getItem("token")
          }
        }).then((res) => {
          if (res.data.ok) {
            this.$notify({
              message: '删除成功',
              type: 'success',
              duration: 2000
            });
          } else {
            this.$notify({
              message: res.data.msg,
              type: 'error'
            });
          }
          this.getList();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    pageSizeChange(Perpage) {
      this.listQuery.Perpage = Perpage;
      this.getList();
    },
    currPageChange(Page) {
      this.listQuery.Page = Page;
      this.getList();
    },
    
    handleStatusChange(row) {
      // 如果当前开关被打开，则关闭其他所有开关
      const parem = {
        StrID: row.StrID,
        Name: row.Name,
        ServerAdd: row.ServerAdd, // 修复：原来是 formModel.StrTitle
        Port: row.Port,
        UserName: row.UserName,
        Password: row.Password,
        DBName: row.DBName,
        Charset:row.Charset,
        UseZ3950:row.UseZ3950
      };
      if (row.UseZ3950) {
        this.list.forEach(item => {
          if (item.StrID !== row.StrID && item.UseZ3950) {
            // 关闭其他激活的开关
          //  this.updateDatabaseStatus(parem);
            item.UseZ3950 = false;
          }
        });
      }
       
      // 更新当前项的状态
      this.updateDatabaseStatus(parem);
      
    },
    
    isSwitchDisabled(row) {
      // 如果当前行是激活状态且列表中有其他激活的项，则不禁止当前项
      // 如果当前行未激活，但列表中有其他激活的项，且当前行不是激活项，则禁止
  //    const activeItems = this.list.filter(item => item.IsActive);
   //   return activeItems.length > 0 && !row.IsActive;
    },
    
    updateDatabaseStatus(params) {
    
      
      this.$axios({
        url: BASE_URL + 'z3950/update',
        method: 'post',
        data: JSON.stringify(params),
        headers: {
          'Content-Type': 'application/json',
          'dataType': 'json',
          'Authorization': localStorage.getItem("token")
        }
      }).then(res => {
        if (!res.data.ok) {
          ElMessage.error(`状态更新失败: ${res.data.msg}`);
          // 如果更新失败，回滚状态
          const item = this.list.find(item => item.StrID === id);
          if (item) {
            item.UseZ3950 = !status;
          }
        } else {
          ElMessage.success("数据库状态修改成功");
        }
      }).catch(error => {
        ElMessage.error('网络错误，状态更新失败');
        // 如果请求失败，回滚状态
        const item = this.list.find(item => item.StrID === id);
        if (item) {
          item.UseZ3950 = !status;
        }
      });
    },
    
  }
};
</script>